import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {BathRoomModel} from '../../../bathrooms/models'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import * as Yup from 'yup'
import {MasterModel, ModuleModel} from '../../../modules/models'
import {yupResolver} from '@hookform/resolvers/yup'
import {Controller, useForm} from 'react-hook-form'
import {getMasterModuleService, getModulesService} from '../../../modules/services'
import {getBathRoomByIdService} from '../../../bathrooms/services/getBathRoomById.service'
import Select from 'react-select'
import {editBathRoomService} from '../../../bathrooms/services/editBathRoom.service'
import {enqueueSnackbar} from 'notistack'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  bathRoomToEdit: BathRoomModel
  getBathRooms: () => void
}

const ModalUpdateBathRoom: FC<Props> = ({show, setShow, bathRoomToEdit, getBathRooms}) => {
  const handleClose = () => {
    setShow(false)
  }
  const [, setModules] = useState<ModuleModel[] | any>([])
  const [bathroomType, setBathRoomType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const newBathRoomSchema = Yup.object().shape({
    ModuloId: Yup.string().required('Módulo es requerido'),
    TipoBanioId: Yup.string().required('Tipo de Baño es requerido'),
    HabitacionId: Yup.string().required('Habitación es requerido'),
    Codigo: Yup.string().required('Código es requerido'),
    SexoId: Yup.string().required('Género es requerido'),
    Observaciones: Yup.string().required('Observaciones es requerido'),
  })
  const {currentTabItem} = useHoteleria()
  useEffect(() => {
    getModules()
    getBathroomsType()
    getGenres()
  }, [])

  const {
    register,
    setValue,
    handleSubmit,
    // watch,
    control,
    formState: {errors},
  } = useForm<BathRoomModel>({
    resolver: yupResolver(newBathRoomSchema),
  })

  const getModules = async () => {
    try {
      const {data: response} = await getModulesService({
        pageNumber: 1,
        size: 1000,
      })
      const mappedModules = response.data?.map((item) => ({value: item.Id, label: item.Codigo}))
      setModules(mappedModules)
    } catch (error) {
      setModules([])
    }
  }

  const getBathroomsType = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoBanio',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBathRoomType(mappedMaster)
    } catch (error) {
      setBathRoomType([])
    }
  }

  const getGenres = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'Sexo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setGenre(mappedMaster)
    } catch (error) {
      setGenre([])
    }
  }

  useEffect(() => {
    if (show) {
      getBathRoomData()
    }
  }, [show])

  const getBathRoomData = async () => {
    try {
      const {
        data: {data},
      } = await getBathRoomByIdService(bathRoomToEdit.Id)
      const {Codigo, ModuloId, Observaciones, SexoId, TipoBanioId} = data
      setValue('Id', bathRoomToEdit.Id)
      setValue('HabitacionId', currentTabItem.idToEdit as any)
      setValue('ModuloId', ModuloId)
      setValue('SexoId', SexoId)
      setValue('TipoBanioId', TipoBanioId)
      setValue('Codigo', Codigo)
      setValue('Observaciones', Observaciones)
    } catch (error) {}
  }

  const onSubmit = async (data: BathRoomModel) => {
    try {
      const {data: res} = await editBathRoomService(data)
      if (!res.error) {
        getSnackBarToast('Se actualizó con exito', 'success')
        handleClose()
        getBathRooms()
        //mostrar snackbar
      } else {
        getSnackBarToast(res.message, 'error')
      }
    } catch (error) {}
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Baño</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Tipo de Baño</label>
                    <div className='input-group input-group-sm'>
                      <Controller
                        control={control}
                        name='TipoBanioId'
                        render={({field}) => (
                          <Select
                            {...field}
                            className='w-100'
                            options={bathroomType}
                            placeholder='Selecciona un tipo de bano'
                            value={bathroomType?.find(
                              (c: {value: string}) => c.value === field.value,
                            )}
                            onChange={(val) => field.onChange(val ? val.value : '')}
                          />
                        )}
                      />
                      <p
                        style={{
                          marginBottom: '0',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: 'red',
                          marginLeft: '5px',
                        }}
                      >
                        {errors.TipoBanioId?.message}
                      </p>
                    </div>
                  </div>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Código de Baño</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Codigo')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Codigo?.message}
                    </p>
                  </div>
                </div>
                <div className='col-6'>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Género</label>
                    <div className='input-group input-group-sm'>
                      <Controller
                        control={control}
                        name='SexoId'
                        render={({field}) => (
                          <Select
                            {...field}
                            className='w-100'
                            options={genre}
                            placeholder='Selecciona un Genero'
                            value={genre?.find((c: {value: string}) => c.value === field.value)}
                            onChange={(val) => field.onChange(val ? val.value : '')}
                          />
                        )}
                      />
                      <p
                        style={{
                          marginBottom: '0',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: 'red',
                          marginLeft: '5px',
                        }}
                      >
                        {errors.SexoId?.message}
                      </p>
                    </div>
                  </div>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Observaciones</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Observaciones')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Observaciones?.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateBathRoom}
